import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';

type Props = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onDeleteAll: () => Promise<void>;
    isDeleting?: boolean;
};

const IntegrationMessagesDeleteAllDialog = ({
    open,
    onOpenChange,
    onDeleteAll,
    isDeleting,
}: Props) => {
    const { t } = useTranslation();
    const [confirmText, setConfirmText] = useState('');

    const handleDeleteAll = async () => {
        await onDeleteAll();
        setConfirmText('');
        onOpenChange(false);
    };

    const handleOpenChange = (nextOpen: boolean) => {
        if (!nextOpen) {
            setConfirmText('');
        }
        onOpenChange(nextOpen);
    };

    return (
        <Dialog open={open} onOpenChange={handleOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{t('integrationMessages.deleteAll.title')}</DialogTitle>
                    <DialogDescription>{t('integrationMessages.deleteAll.description')}</DialogDescription>
                </DialogHeader>

                <label className="flex flex-col gap-1 text-sm">
                    <span>{t('integrationMessages.deleteAll.confirmLabel')}</span>
                    <input
                        type="text"
                        value={confirmText}
                        onChange={(event) => setConfirmText(event.target.value)}
                        className="rounded-lg border border-lightgray bg-base px-3 py-2"
                        placeholder={t('integrationMessages.deleteAll.confirmPlaceholder')}
                    />
                </label>

                <DialogFooter>
                    <Button variant="outline" onClick={() => handleOpenChange(false)}>
                        {t('integrationMessages.actions.cancel')}
                    </Button>
                    <Button
                        variant="destructive"
                        disabled={
                            confirmText !== t('integrationMessages.deleteAll.confirmWord') || isDeleting
                        }
                        onClick={() => void handleDeleteAll()}
                    >
                        {t('integrationMessages.actions.deleteAllConfirm')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default IntegrationMessagesDeleteAllDialog;
